"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_970 = exports.Plan_969 = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Plan_969 = exports.Plan_969 = {
  planNumber: 969,
  kindOfCover: "Accident & GVE",
  externalName: "Platinum Cover",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: true,
  routineCare: false,
  emergencyBoarding: true,
  emergencyBoardingFees: "$1,500",
  petSpecies: ["CANINE", "FELINE"],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3965",
    "excessNo": 3965
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "3966",
    "excessNo": 3966
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "3967",
    "excessNo": 3967
  }],
  levelsOfCover: [80],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  limits: {
    "ageLimits": {
      "minAgeDays": 55,
      "maxAgeDays": 3287,
      "displayValue": "Older than 8 weeks and younger than 9 years"
    },
    "annualLimit": {
      "amount": 30000,
      "formattedAmount": "$30,000",
      "displayValue": "$30,000"
    },
    "dentalCareLimit": "$1,000",
    "emergencyBoardingFees": "$1,500",
    "emergencyBoardingLimit": "$1,500 sub-limit"
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["No waiting period for specified accidental injuries.", "21 days for general veterinary expenses.", "No waiting period for emergency boarding.", "6 months for dental illness treatments where selected."],
      "waitingPeriod": "No waiting period for specified accidental injuries.<br/>21 days for general veterinary expenses.<br/>No waiting period for emergency boarding.<br/>6 months for dental illness treatments where selected.",
      "itemisedWaitingPeriods": {
        "specifiedAccidentalInjuries": {
          "waitTime": "No waiting period",
          "label": "specified accidental injuries"
        },
        "generalVeterinaryExpenses": {
          "waitTime": "21 days",
          "label": "general veterinary expenses"
        },
        "emergencyBoarding": {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        },
        "dental": {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        }
      }
    }
  },
  customCoverDetails: {
    "coversIllness": true,
    "infectiousDisease": true,
    "toxicityPoisoning": true,
    "trichobezoar": true,
    "ingestionOfForeignBodies": true,
    "ingestionToxicity": true
  },
  isBasePlan: true,
  addOns: ["dental"]
};
var Plan_970 = exports.Plan_970 = _objectSpread(_objectSpread({}, Plan_969), {}, {
  planNumber: 970,
  externalName: "Platinum Cover with Routine Care",
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3968",
    "excessNo": 3968
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "3969",
    "excessNo": 3969
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "3970",
    "excessNo": 3970
  }],
  limits: _objectSpread(_objectSpread({}, Plan_969.limits), {}, {
    dentalLimitBreakDown: undefined,
    routineCareLimit: "$150",
    routineCareLimitBreakDown: [{
      "description": "Routine Group",
      "code": "RGPINSCOM",
      "limit": 100
    }, {
      "description": "Routine Group",
      "code": "RGPINS_PLU",
      "limit": 50
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_969.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_969.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["No waiting period for specified accidental injuries.", "21 days for general veterinary expenses.", "No waiting period for emergency boarding.", "6 months for dental illness treatments where selected.", "No waiting period for routine care where selected."],
      waitingPeriod: "No waiting period for specified accidental injuries.<br/>21 days for general veterinary expenses.<br/>No waiting period for emergency boarding.<br/>6 months for dental illness treatments where selected.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_969.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 969,
  addOns: ["dental", "routineCare"],
  isBasePlan: false
});
var _default = exports["default"] = {
  Plan_969: Plan_969,
  Plan_970: Plan_970
};